import React from "react";
import AboutWrapper from "./AboutWrapper";

const About = () => {

  return (
    <>
      <AboutWrapper />
    </>
  );
}

export default About;
